import React, { useEffect, useState } from "react";
import api from "../services/api";
import { toast } from "react-toastify";

const UserModal = ({
    show,
    handleClose,
    selectedUser,
    loadUsers
}) => {

    const [formData, setFormData] = useState({

        username: "",
        password: "",
        shop_name: "",
        person_name: "",
        mobile_no: "",
        role: "user"

    });

    useEffect(() => {

        if (selectedUser) {

            setFormData({

                username: selectedUser.username,
                password: "",
                shop_name: selectedUser.shop_name,
                person_name: selectedUser.person_name,
                mobile_no: selectedUser.mobile_no,
                role: selectedUser.role

            });

        } else {

            setFormData({

                username: "",
                password: "",
                shop_name: "",
                person_name: "",
                mobile_no: "",
                role: "user"

            });

        }

    }, [selectedUser]);

    const handleChange = (e) => {

        setFormData({

            ...formData,
            [e.target.name]: e.target.value

        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            if (selectedUser) {

                await api.put(

                    `/users/${selectedUser.id}`,

                    formData

                );

                toast.success("User Updated Successfully");

            } else {

                await api.post(

                    "/users",

                    formData

                );

                toast.success("User Added Successfully");

            }

            loadUsers();

            handleClose();

        } catch (error) {

            toast.success(

                error.response?.data?.message ||

                "Something went wrong"

            );

        }

    };

    if (!show) return null;

    return (

        <div
            className="modal d-block"
            style={{
                background: "rgba(0,0,0,0.5)"
            }}
        >

            <div className="modal-dialog modal-lg">

                <div className="modal-content">

                    <div className="modal-header bg-primary text-white">

                        <h5>

                            {
                                selectedUser ?

                                    "Edit User"

                                    :

                                    "Add User"

                            }

                        </h5>

                        <button
                            className="btn-close btn-close-white"
                            onClick={handleClose}
                        ></button>

                    </div>

                    <form onSubmit={handleSubmit}>

                        <div className="modal-body">

                            <div className="row">

                                <div className="col-md-6 mb-3">

                                    <label>Username</label>

                                    <input

                                        type="text"

                                        name="username"

                                        className="form-control"

                                        value={formData.username}

                                        onChange={handleChange}

                                        required

                                    />

                                </div>

                                <div className="col-md-6 mb-3">

                                    <label>
                                        Password
                                        {selectedUser && (
                                            <small className="text-muted ms-2">
                                                (Leave blank to keep current password)
                                            </small>
                                        )}
                                    </label>

                                    <input

                                        type="password"

                                        name="password"

                                        className="form-control"

                                        value={formData.password}

                                        onChange={handleChange}

                                        required={!selectedUser}

                                    />

                                </div>

                                <div className="col-md-6 mb-3">

                                    <label>Shop Name</label>

                                    <input

                                        type="text"

                                        name="shop_name"

                                        className="form-control"

                                        value={formData.shop_name}

                                        onChange={handleChange}

                                        required

                                    />

                                </div>

                                <div className="col-md-6 mb-3">

                                    <label>Person Name</label>

                                    <input

                                        type="text"

                                        name="person_name"

                                        className="form-control"

                                        value={formData.person_name}

                                        onChange={handleChange}

                                        required

                                    />

                                </div>

                                <div className="col-md-6 mb-3">

                                    <label>Mobile Number</label>

                                    <input

                                        type="text"

                                        name="mobile_no"

                                        className="form-control"

                                        value={formData.mobile_no}

                                        onChange={handleChange}

                                        required

                                    />

                                </div>

                                <div className="col-md-6 mb-3">

                                    <label>Role</label>

                                    <select

                                        name="role"

                                        className="form-control"

                                        value={formData.role}

                                        onChange={handleChange}

                                    >

                                        <option value="user">

                                            User

                                        </option>
                                        {selectedUser && (
                                        <option value="admin">

                                            Admin

                                        </option>
                                        )}

                                    </select>

                                </div>

                            </div>

                        </div>

                        <div className="modal-footer">

                            <button
                                className="btn btn-secondary"
                                type="button"
                                onClick={handleClose}
                            >

                                Cancel

                            </button>

                            <button
                                className="btn btn-primary"
                                type="submit"
                            >

                                {

                                    selectedUser ?

                                        "Update"

                                        :

                                        "Save"

                                }

                            </button>

                        </div>

                    </form>

                </div>

            </div>

        </div>

    );

};

export default UserModal;